import { memo, useCallback } from 'react';
import { Box, Typography, useColorScheme } from '@mui/joy';

import { useDispatcher, useSelector } from 'store/utils/redux/hooks';

import StripeElementsWrapper from 'components/StripeElementsWrapper';

import DualPanels from 'widgets/DualPanels';
import SubscriptionTryFree from 'widgets/Subscription/TryFree';

import * as onboardingSelectors from '../store/selectors';
import usePlanState from '../model/usePlanState';

import StripeContainer, { type StripeContainerProps } from '../components/StripeContainer';
import SkipButton from '../ui/SkipButton';

// import BcgIcon from '../assets/bcg.svg';
// import McIcon from '../assets/mc.svg';
// import MiroIcon from '../assets/miro.svg';
// import PwcIcon from '../assets/pwc.svg';

const backgroundDark = {
  imageBackground: require('widgets/Onboarding/assets/profile.jpg'),
};
const backgroundWhite = {
  imageBackground: require('widgets/Onboarding/assets/about.jpg'),
};

const AppsumoUpgradePlan = () => {
  const dispatcher = useDispatcher();

  const { mode } = useColorScheme();

  const isSkipping = useSelector(onboardingSelectors.isSkipLoading);
  const isLoading = useSelector(onboardingSelectors.isLoading);

  const { value: planId, handleChange: handlePlanChange } = usePlanState();

  const handleSkip = useCallback(() => {
    dispatcher.onboarding.skip({ target: 'appsumoUpgrade' });
  }, []);

  const handleStart: StripeContainerProps['onStart'] = useCallback((params) => {
    dispatcher.onboarding.startPlan({ ...params, trial: false });
  }, []);

  return (
    <DualPanels
      sx={{
        '--left-max-width': '40rem',
        '--panel-max-width': '400px',
      }}
      leftPanel={
        <>
          <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
            <Typography mx={2} fontSize={52} fontWeight={600} textAlign="center">
              Upgrade your plan
            </Typography>
            <Typography fontSize={16} fontWeight={400} maxWidth={400} textAlign="center">
              You can cancel at any time.
            </Typography>
            <StripeElementsWrapper>
              <StripeContainer
                isSkipLoading={isSkipping}
                planId={planId}
                onPlanChange={handlePlanChange}
                onStart={handleStart}
                confirmLabel="Upgrade"
                confirmIcon={false}
              />
            </StripeElementsWrapper>
            <Box alignSelf="center" display="flex" flexDirection="row" alignItems="baseline" mt={1} pl={3} gap={0.5}>
              <SkipButton onClick={handleSkip} loading={isSkipping} disabled={isLoading} label="Not now" />
            </Box>
          </Box>
        </>
      }
      rightPanel={
        <Box display="flex" alignItems="center" justifyContent="center" flex={1} sx={{ opacity: 0.9 }}>
          <Box display="flex" flexDirection="column" alignItems="center" width="100%">
            <SubscriptionTryFree planId={planId} />
            {/* <Typography fontSize={20} mt={8}>
              Trusted by people and teams from
            </Typography>
            <Box display="flex" flexDirection="row" width="100%" maxWidth={500} justifyContent="space-between">
              <BcgIcon />
              <McIcon />
              <MiroIcon />
              <PwcIcon />
            </Box> */}
          </Box>
        </Box>
      }
      rightPanelBackGround={mode === 'dark' ? backgroundDark : backgroundWhite}
    />
  );
};

export default memo(AppsumoUpgradePlan);
